import { ChangePasswordAction, onChangeAuth } from "page/auth/redux"
import { useRedux } from "redux/useRedux"

import { Form, notification } from "antd";
import { useNavigate } from "react-router-dom";
import { AuthContext } from 'contexts/auth-context';
import { useContext } from 'react';


const LoginLogic = () => {
    const navigate = useNavigate()
    const [formForget] = Form.useForm()
    const ctx = useContext(AuthContext);
    const { dispatch, authState } = useRedux()
    async function ChangePasswordFunction() {
        console.log(formForget.getFieldsValue());
        var query =`phone=${authState.phoneOfChangePassword}&verifyCode=${formForget.getFieldsValue().verifyCode}&password=${encodeURIComponent(formForget.getFieldsValue().password)}&confirmPassword=${encodeURIComponent(formForget.getFieldsValue().confirmPassword)}`
console.log(query);

        await dispatch(ChangePasswordAction(query)).then((res) => {
            notification.success({
                message: "",
                description: res.messages,
                placement: 'bottomLeft',
            });
        dispatch(onChangeAuth("status", "login"))

        })
      
    }
    return {
        formForget, ChangePasswordFunction
    }

}
export default LoginLogic;